import { GetterTree } from 'vuex';
import * as types from './types';

export default <GetterTree<gnb.state.GnbState, RootState>>{

    [types.LANGUAGE_LOAD](state) {
        return state.languageFields;
    },

    [types.TIME_LOAD](state) {
        return state.timeFields;
    },
  
    [types.SETTINGS_MYSETTING_DATA](state){
        return state.settings.mySetting;
    },

    
    [types.APPLICATION_LIST_DATA](state){
        return state.settings.applicationList;
    },

    [types.SETTINGS_DELEGATOR_LIST_DATA](state){
        return state.settings.delegate;
    },
    
    [types.COMMON_LOADDING](state) {
        return state.isLoading;
    },
    
    [types.SET_CHANGE_LANG_FLAG](state) {
        return state.isChangedLang;
    },
    
    [types.APPLICATION_SELECTLIST_DATA](state){
        return state.settings.applicationList.selectApplicationList;
    },

    [types.CARDSTATE](state) {
        return state.cardState;
    },

    [types.COMPANY_CARD](state) {
        return state.companyCards;
    },

    [types.FREECONTENT](state) {
        return state.userCard?.freeContent || '';
    },

    [types.COMPANY_LOGO](state) {
        return state.companyLogo;
    }
};
